<!-- Hero Section -->
<section class="market-hero">
  <div class="market-hero__content">
    <p class="market-hero__tagline">{{ heroText }}</p>
  </div>
</section>

<!-- Top Categories (with hero banner above) -->
<section class="market-section market-section--overlap">
  <div class="section-container">
    @if (heroBannerSrc(); as src) {
      <a [href]="heroBannerUrl() || 'javascript:void(0)'" class="landing-hero-banner-link">
        <img [src]="src" alt="Landing page hero banner"
             class="img-fluid w-100 landing-hero-banner"
             loading="eager" fetchpriority="high" />
      </a>
    }
    <div class="row g-4">
      @for (category of topCategories(); track category.id) {
      <div class="col-sm-6">
        <div class="category-card category-card--clickable" [class.category-card--highlighted]="category.isSpecial"
          (click)="navigateToCategory(category.name)">
          <h2 class="category-card__title">{{ category.name }}</h2>
          <div class="category-card__grid">
            @for (product of category.products; track product.id) {
            <div class="category-card__item">
              <div class="category-card__img product-img-wrapper" (click)="navigateToProduct(product.seoUrl, $event)">
                <img [src]="product.image || 'assets/images/product-placeholder.webp'" [alt]="product.name"
                  (error)="onImgError($event)" loading="lazy" width="300" height="300">
                @defer (on viewport) {
                <ng-container [ngTemplateOutlet]="productOverlays"
                  [ngTemplateOutletContext]="{ $implicit: product.id }" />
                } @placeholder {
                <span></span>
                }
              </div>
              <a [routerLink]="'/shop/' + product.seoUrl" class="category-card__name"
                (click)="$event.stopPropagation()">{{ product.name }}</a>
            </div>
            }
          </div>
          <a [routerLink]="getShopAllLink(category.name)" class="category-card__link"
            (click)="$event.stopPropagation()">{{ getShopAllText(category.name) }}</a>
        </div>
      </div>
      }
    </div>
  </div>
</section>

<!-- Customer Favorites -->
<section class="market-favorites">
  <div class="section-container">
    @if (customerFavoritesCategory(); as favCategory) {
    <div class="market-favorites__card market-favorites__card">
      <h2 class="market-favorites__title">{{ favCategory.name }}</h2>
      <p class="market-favorites__subtitle">See what customers love and have been buying since 2013.</p>
      <div class="market-favorites__grid">
        @for (product of favCategory.products; track product.id) {
        <div class="market-favorites__item">
          <div class="product-img-wrapper" (click)="navigateToProduct(product.seoUrl, $event)">
            <img [src]="product.image || 'assets/images/product-placeholder.webp'" [alt]="product.name"
              (error)="onImgError($event)" loading="lazy" width="300" height="225">
            @defer (on viewport) {
            <ng-container [ngTemplateOutlet]="productOverlays" [ngTemplateOutletContext]="{ $implicit: product.id }" />
            } @placeholder {
            <span></span>
            }
          </div>
          <a [routerLink]="'/shop/' + product.seoUrl" class="market-favorites__name"
            (click)="$event.stopPropagation()">{{ product.name }}</a>
        </div>
        }
      </div>
      <!-- <div class="text-end mt-3">
          <a [routerLink]="getShopAllLink(favCategory.name)" class="category-card__link">{{ getShopAllText(favCategory.name) }}</a>
        </div> -->
    </div>
    }
  </div>
</section>

<!-- Bottom Categories -->
<section class="market-section mb-5">
  <div class="section-container">
    <div class="bottom-categories-grid">
      @for (category of bottomCategories(); track category.id) {
      <div class="bottom-categories-grid__item">
        <div class="category-card category-card--clickable" [class.category-card--highlighted]="category.isSpecial"
          (click)="navigateToCategory(category.name)">
          <h2 class="category-card__title">{{ category.name }}</h2>
          <div class="category-card__grid">
            @for (product of category.products; track product.id) {
            <div class="category-card__item">
              <div class="category-card__img product-img-wrapper" (click)="navigateToProduct(product.seoUrl, $event)">
                <img [src]="product.image || 'assets/images/product-placeholder.webp'" [alt]="product.name"
                  (error)="onImgError($event)" loading="lazy" width="300" height="300">
                @defer (on viewport) {
                <ng-container [ngTemplateOutlet]="productOverlays"
                  [ngTemplateOutletContext]="{ $implicit: product.id }" />
                } @placeholder {
                <span></span>
                }
              </div>
              <a [routerLink]="'/shop/' + product.seoUrl" class="category-card__name"
                (click)="$event.stopPropagation()">{{ product.name }}</a>
            </div>
            }
          </div>
          <a [routerLink]="getShopAllLink(category.name)" class="category-card__link"
            (click)="$event.stopPropagation()">{{ getShopAllText(category.name) }}</a>
        </div>
      </div>
      }
    </div>
  </div>
</section>

<!-- Shared template for product detail overlays -->
<ng-template #productOverlays let-productId>
  <span [class.loaded]="onProductVisible(productId)" hidden></span>
  @if (hasBundle(productId)) {
  <button class="whats-inside-btn" (click)="openWhatsInside(getProductDetail(productId)!, $event)">What's
    inside</button>
  }
  @if (isOnSale(productId)) {
  <span class="sale-badge material-symbols-outlined">percent</span>
  }
</ng-template>

<app-footer></app-footer>